/* eslint-disable react/jsx-closing-tag-location */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Classes from '../Classes';

const Label = ({
  value, borderColour
}) => (
  <div>
    {borderColour !== null && borderColour !== undefined
      ? (
        <span
          data-testid="Label"
          className={classnames(Classes.featureLabel)}
          title={value}
          style={{ border: `1px solid ${borderColour}` }}
        >
          {value}
        </span>
      )
      : (<span className={classnames(Classes.featureLabel)} title={value}>{value}</span>)}

  </div>
);

Label.propTypes = {
  value: PropTypes.string.isRequired,
  borderColour: PropTypes.string

};

export default Label;
